import { CategoryPicker } from './CategoryPicker';
import React from 'react';
import { Badge as BadgeStyle } from 'src/components/atoms';
import { CategorisedType } from 'src/types';
import styled from 'styled-components';

export type SelectCategoryProps = {
  size?: 'small' | 'large';
  addCategory: (category: CategorisedType) => void;
  categories: CategorisedType[];
  margin?: string;
  isRadio?: boolean;
};

const Badge = styled(BadgeStyle)`
  &:hover {
    background-color: ${(props) => props.theme.newPalette.neutral.N300};
    cursor: pointer;
  }
  border: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
`;

export const SelectCategory = (props: SelectCategoryProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const addCategory = (category: CategorisedType) => {
    setAnchorEl(null);
    if (category?.name.length) {
      props.addCategory(category);
    }
  };

  return (
    <>
      <Badge
        data-testid={'select-category-button'}
        text={props.size === 'small' ? '+' : 'Add +'}
        variant={'custom'}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          setAnchorEl(event?.currentTarget);
        }}
      />
      {open && (
        <CategoryPicker
          open={open}
          addCategory={addCategory}
          categories={props.categories}
          anchorEl={anchorEl}
          isRadio={props.isRadio}
        />
      )}
    </>
  );
};
